

































































import { Component, Vue, Prop } from 'vue-property-decorator';
import Create from './Service/Create';
import DoModify from './Service/DoModify';

import depForm from './form';

@Component
export default class roleCreate extends Vue {
  @Prop({})
  private form: any;

  private depForm: Object = depForm;

  private role: Array<Object> = [];

  private roleList: Array<Object> = [];

  private keepCreate: boolean = false; // 判定: 繼續新增

  /** 送出表單 */
  public async submitForm(formName: string) {
    /** 測試模式判定 */
    const myForm: any = this.$refs[formName];
    myForm.validate(async (valid: boolean) => {
      if (valid) {
        const getter = (await new DoModify(this.form).put()) as any;
        if (getter.data && getter.data.code === 0) {
          this.$emit('close');
          this.$emit('update');
        }
      } else {
        const msg: any = this.$t('Util.validateError');
        this.$message.error(msg);
      }
    });
  }

  /** 清除表單 */
  private resetForm(formName: string) {
    const myForm: any = this.$refs[formName];
    myForm.resetFields();
  }

  private mounted() {
    this.$bus.$on('save', () => {
      this.submitForm('form');
    });
  }
}
